import React from 'react';
import { RoundScrollButton } from '../elements/ScrollButton';
import { sectionPropTypes } from './Section';

var SectionButton = function SectionButton(_ref) {
  var item = _ref.item;
  return /*#__PURE__*/React.createElement(RoundScrollButton, {
    color: item.color,
    icon: item.icon,
    to: item.target
  }, item.title);
};

var SectionButtons = function SectionButtons(_ref2) {
  var sections = _ref2.sections;
  return /*#__PURE__*/React.createElement("div", null, (sections || []).map(function (item) {
    return /*#__PURE__*/React.createElement(SectionButton, {
      item: item,
      key: item.target
    });
  }));
};

export default SectionButtons;